import { useEffect } from 'react';
import { api } from '../api';

/** Sets document.title to "<event name> — <suffix>" once the (public, unauthenticated) event data loads. */
export function usePageTitle(eventSlug: string | undefined, suffix: string) {
  useEffect(() => {
    let cancelled = false;
    api
      .getEvent(eventSlug)
      .then((event) => {
        if (!cancelled) document.title = `${event.name} — ${suffix}`;
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [eventSlug, suffix]);
}
